import { useEffect, useState } from "react";
import { fileUrl } from "./gmao";
import { fileSrc } from "./offline";

// URL para <img>: la del servidor con conexión; la copia del dispositivo (plano descargado o foto tomada sin cobertura) si no la hay.
export function useFileSrc(fileId) {
  const [src, setSrc] = useState(() => fileUrl(fileId));
  useEffect(() => {
    let alive = true;
    fileSrc(fileId, fileUrl(fileId)).then((u) => { if (alive) setSrc(u); });
    return () => { alive = false; };
  }, [fileId]);
  return src;
}
